import { useToggleState } from '@cian/react-utils';
import { Button, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';
import { useE2eLabelTracking, useMainFormQuestionHandlers } from '../../hooks';
import { trackE2eInfoPopupShow } from '../../utils/tracking';
import { ContainerLayout } from '../ContainerLayout';
import { E2eDealDescriptionModal } from '../E2eDealDescriptionModal';
import { ErrorText } from '../ErrorText';
import * as styles from './style.css';
import { IMainFormQuestion } from '../../types';

interface IMainFormQuestionLayoutProps extends IMainFormQuestion, ReturnType<typeof useMainFormQuestionHandlers> {
  isLoading: boolean;
  isError: boolean;
}

export const MainFormQuestionLayout: React.FC<IMainFormQuestionLayoutProps> = props => {
  const { state: modalState, toggle: toggleModal } = useToggleState();
  const isMobile = useDeviceType() === 'phone';
  const questionSeparator = isMobile ? '/' : ' из ';
  const onTrackE2eInfoPopupShow = useE2eLabelTracking(trackE2eInfoPopupShow);

  const openModal = () => {
    onTrackE2eInfoPopupShow({});
    toggleModal();
  };

  return (
    <ContainerLayout
      title={
        isMobile
          ? 'Попробуйте усилить ваше объявление значком «Онлайн-сделка»'
          : 'Попробуйте усилить ваше объявление значком'
      }
      content={
        <>
          <UIText2 display="inline">
            Ответьте на {props.totalQuestionsCount} вопроса: если объект подходит, мы отметим объявление.{' '}
            {!isMobile && <br />}Значок покажет, что с вашим объектом можно быстро и безопасно провести сделку.{' '}
            {!isMobile && <br />}
          </UIText2>
          <span className={styles['modal-open-link']}>
            <UIText2 onClick={openModal} color="primary_100" display="inline">
              Что такое онлайн-сделка
            </UIText2>
            <E2eDealDescriptionModal open={modalState} onClose={toggleModal} />
          </span>
          <div className={cn(styles['question'], isMobile && styles['question-mobile'])}>
            <div className={cn(styles['question-count'], isMobile && styles['question-count-mobile'])}>
              <UIText2 color={'gray60_100'}>
                {props.questionNumber}
                {questionSeparator}
                {props.totalQuestionsCount}
              </UIText2>
            </div>
            <div className={cn(styles['question-text'], isMobile && styles['question-text-mobile'])}>
              <UIText1 fontWeight="700">{props.question}</UIText1>
            </div>
          </div>
        </>
      }
      isWithRightSideImage
      isWithRingLabelImage
      actions={
        <>
          <Button loading={props.isLoading} theme="fill_white_primary" onClick={props.onAnswerYes}>
            {props.answerYes}
          </Button>
          <Button disabled={props.isLoading} theme="fill_white_primary" onClick={props.onAnswerNo}>
            {props.answerNo}
          </Button>
          {props.isError && <ErrorText />}
        </>
      }
    />
  );
};
